export type Retail360_Anticipated_Visits = "Retail360_Anticipated_Visits";
export type Retail360_Anticipated_Visits_Redesign = "Retail360_Anticipated_Visits_Redesign";

export type FlowId = Retail360_Anticipated_Visits | Retail360_Anticipated_Visits_Redesign;

export const flowId: FlowId = "Retail360_Anticipated_Visits_Redesign";
export type BillPageURL = "https://www.xfinity.com/bill-pay";
export type CancelServiceURL =
  "https://www.xfinity.com/xfinityassistant/?intent=other-style_retention-chat&refferer=hs_retention_chat";
export type CancelOverPhoneURL = "https://www.xfinity.com/support/cancel-service";
export type BereavementURL = "https://www.xfinity.com/support/account-management/bereavement";
export type CalculateSavingURL = "https://www.xfinity.com/mobile/learn/plan";

export type LinkType = BillPageURL | CancelServiceURL | CancelOverPhoneURL | BereavementURL | CalculateSavingURL;

export const billPageURL: LinkType = "https://www.xfinity.com/bill-pay";
export const cancelServiceURL: LinkType =
  "https://www.xfinity.com/xfinityassistant/?intent=other-style_retention-chat&refferer=hs_retention_chat";
export const cancelOverPhoneURL: LinkType = "https://www.xfinity.com/support/cancel-service";
export const bereavementURL: LinkType = "https://www.xfinity.com/support/account-management/bereavement";
export const calculateSavingURL: LinkType = "https://www.xfinity.com/mobile/learn/plan";
